import React from 'react';
import styles from './Confirmation.module.scss';
import {useLocation, useNavigate} from 'react-router-dom';
import {useActions} from "../../hook/useActions";

const Confirmation = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const email = searchParams.get('email');
    const token = searchParams.get('token');
    const [isEmailConfirmed, setIsEmailConfirmed] = React.useState(false);
    const {ConfirmEmailAsync} = useActions();

    const navigate = useNavigate();

    const handleClick = async () => {
        if (email && token) {
            try {
                await ConfirmEmailAsync({ email, token });
                setIsEmailConfirmed(true);
            } catch {}
        } else {
            alert('Invalid confirmation link.');
        }
    };

    if (isEmailConfirmed) {
        return (
            <div className={styles.successContainer}>
                <div className={styles.successHeader}>
                    <img className={styles.successLogo} src="/images/miniLogoV2.png" />
                    <div className={styles.successTitle}>ВЕДИЧНА АКАДЕМІЯ =ЕКАДАШІ=</div>
                </div>
                <div className={styles.successMessageRow}>
                    <div className={styles.successMessage}>
                        Вы успешно подтвердили свой адрес
                        <br />
                        электронной почты для верификации
                        <br />
                        своей учетной записи
                    </div>
                </div>
                <div className={styles.successContentWrapper}>
                    <div className={styles.successBoxWrapper}>
                        <div className={styles.successBox} onClick={() => {navigate('/login')}}>
                            <div className={styles.successBoxText}>ВХОД в аккаунт</div>
                        </div>
                        <img
                            className={styles.successIcon}
                            src="/images/shlyapa.png"
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img className={styles.logoWrapper} src="/images/miniLogoV2.png"/>
                <div className={styles.title}>ВЕДИЧНА АКАДЕМІЯ =ЕКАДАШІ=</div>
            </div>
            <div className={styles.subtitleRow}>
                <div className={styles.subtitle}>
                    Підтвердьте свою адресу електронної пошти
                    <br/>
                    для верифікації свого облікового запису
                </div>
            </div>
            <div className={styles.contentWrapper}>
                <div className={styles.emailBoxWrapper}>
                    <div className={styles.emailBox} onClick={handleClick}>
                        <div className={styles.emailText}>Підтвердити адресу електронної пошти</div>
                    </div>
                    <img
                        className={styles.emailIcon}
                        src="/images/email.png"
                    />
                </div>
            </div>
        </div>
    );
}

export default Confirmation;
